import { axiosInstance } from "../client";
import { DossierType } from "@rumble-it/common-lib/types/models/DossierType.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

export const fetchDossierTypesWithoutPagination = async (): Promise<
  CollectionResponse<DossierType>
> => axiosInstance.get(`/dossiers/types`).then((response) => response.data);
